import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, Input, OnDestroy, OnInit} from "@angular/core";
import {Widget} from "@ispm/widgets/decorator/widget.decorator";
import {IWidgetItem} from "@ispm/widgets/interfaces/widget-item.interface";
import {IspmHttpClient} from "@ispm/core/services/ispm-http-client";
import {HttpInterceptorService} from "@ispm/core/services/http-interceptor.service";
import {Subject} from "rxjs";
import {FormGroup} from "@angular/forms";
import {UserActionCreatorService} from "@ispm/user/services/user-action-creator.service";
import {FileService} from "@ispm-client/modules/file-module/services/file.service";
import {DynamicApiService} from "../../../../app/export/services/dynamic-api.service";
import { NotificationMessageService } from "@ispm/core/components/customise-notification/notifications-message.service";
import {CryptoService} from "@ispm/migration/services/crypto.service";


@Component({
  selector: 'gen-replace-report-template',
  templateUrl: './replace-report-template.component.html',
  styleUrls: ['./replace-report-template.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
@Widget('replace-report-template')
export class ReplaceReportTemplateComponent implements OnInit, OnDestroy, IWidgetItem<any> {

  private key: string;
  private iterations: number;
  public _formConfig: Array<any>;
  public widgetFormInstance: FormGroup;
  private _widgetFormInstanceSubmitted: boolean;

  public widgetPayload:any;
  private destroyed$: Subject<any> = new Subject();
  public inputConfig= [];
  widgetUpdateValueCallback: (value) => void;
  widgetSubmitStatusValueCallback: (value: boolean) => void;
  public listenToDataChange = true;
  public formData: any;
  private submitUri = 'reporttemplate/replace';
  private report: any;
  public fileName: any;
  private application: string;
  private id: string;
  private type: string;
  private status: string;
  private templateId: string;
  private file: any;
  private fileJson: any;
  private testName: any;
  managingOrganization: any;
  constructor(private _ispmHttpClient: IspmHttpClient,
              private _isgHttpClient: HttpInterceptorService,
              private notificationMessageService: NotificationMessageService,
              private _changeDetector: ChangeDetectorRef,
              private _UserActionCreatorService: UserActionCreatorService,
              private _dynamicApiService: DynamicApiService,
              private _fileService: FileService,
              private cryptoService: CryptoService) {
  }

  ngOnInit() {
  }


  set widgetData(widgetData:any){
    this.formData = widgetData;
    if(this.formData) {
      this._changeDetector.markForCheck();
    }

  }
  set widgetConfig(widgetConfig) {

    this.widgetPayload = widgetConfig.widgetPayload;
    this._formConfig = this.widgetPayload.formConfig;
  }


  public get widgetFormInstanceSubmitted(){
    return this._widgetFormInstanceSubmitted;
  }

  public formreplace(form){
    // this.application = form.application;
    // this.testId = form.testId;
    // this.type = form.type;
    // this.status = form.status;
    // this.templateId = form.templateId;
    // this.testName = form.testName;
    // this.file = form.file;
    // this.fileJson = form.fileJson,
    this.managingOrganization = form.managingOrganization;
    this.id = form.id;
    this._changeDetector.markForCheck();
  }

  public set widgetFormInstanceSubmitted(widgetFormInstanceSubmitted: boolean){
    this._widgetFormInstanceSubmitted = widgetFormInstanceSubmitted;
    this._changeDetector.markForCheck();
    this.replaceReportTemplate()
  };

  public replaceReportTemplate() {

      const body = {
        id:this.id,
        managingOrganization:this.managingOrganization
      };

      // const body = {
      //   test : {  id : this.testId,
      //              name : this.testName},
      //   type : this.type,
      //   status : this.status,
      //   templateId : this.templateId,
      //   file : this.file.referenceId,
      //   json : this.fileJson.referenceId,
      //   orgId : JSON.parse(sessionStorage.getItem('Orgnization')).id,
      //   user : JSON.parse(localStorage.getItem('user')).username
      // };

      this._ispmHttpClient.put(this.submitUri, body).subscribe(
        result => {
          this._dynamicApiService.setReloadWorklistStatus(true);
          this.notificationMessageService.success('Organization Access updated Successfully');
          console.log("Organization Access update succeeded", result);
          this.widgetSubmitStatusValueCallback.apply(this, [false]);
        },
        error => {
          this.widgetSubmitStatusValueCallback.apply(this, [false]);
          this.notificationMessageService.error('Failed to Update Organization Access' + this.getErrorMessage(error.message));
          console.log("Organization Access error", error);
        }
      );
      this._changeDetector.markForCheck();
  }

  private getErrorMessage(msg: string){
    const msgs = msg.split(':');
    return msgs[msgs.length-1];
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
    this._changeDetector.detach();
  }
}


